import React, { useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Col,
  Row,
  Label,
} from "reactstrap";
import TextEditor from "components/editor/TextEditor";
import { useFormik } from "formik";
import * as Yup from "yup";
import { httpRequest } from "utils/httpRequest";
import { toast } from 'react-toastify';
import CircleLoader from "components/loader/CircleLoader"
import { useLoader } from 'components/loader/useLoader';
import {useState} from "react"


const AboutUs = () => {


  const { loading, startLoading, stopLoading } = useLoader()
   const [buttonLoading, setButtonLoading] = useState(false);


  // Validation Schema
  const validationSchema = Yup.object().shape({
    aboutUs: Yup.string()
      .required("About Us data is required")
      .test('not-empty-html', 'About Us data is required', function (value) {
        if (!value) return false;
        // Remove HTML tags and check if there's actual content
        const textOnly = value.replace(/<[^>]*>/g, '').trim();
        return textOnly.length > 0;
      })
  });

  const formik = useFormik({
    initialValues: {
      aboutUs: ""
    },
    validationSchema,
    onSubmit: async (values) => {
      formik.setTouched({

        aboutUs: true
      });

      const errors = await formik.validateForm();

      if (Object.keys(errors).length > 0) return false;

      setButtonLoading(true)
      try {
        const response = await httpRequest(
          "cms/updateAboutUs",
          "POST",
          {
            content: values?.aboutUs,

          },
          {},
          true
        );
        if (response?.code === 200) {
      
          getAboutUs()
          toast.success("About us added successfully")


        }

      } catch (error) {
        console.log(error)
      }finally{
        setButtonLoading(false)
      }
    },
  });



  useEffect(() => {
    getAboutUs()
  }, [])



  const getAboutUs = async () => {
    startLoading()
    try {
      const response = await httpRequest(
        "cms/getAboutUs",
        "GET",
        {},
        {},
        true
      );
      if (response?.code === 200) {
        formik.setValues({ aboutUs: response?.data?.content })


      }

    } catch (error) {
      console.log(error);
    } finally {
      stopLoading()
    }
  }










  return (
    <>
      {loading ? <CircleLoader /> : (<Row className="mt-4 justify-content-center">
        <Col lg="8">
          <Card className="bg-secondary shadow border-0">
            <CardHeader className="bg-transparent pb-3">
              <div className="text-muted text-center mt-2 mb-3">
                <small>About US</small>
              </div>
            </CardHeader>
            <CardBody className="px-lg-5 py-lg-4">
              <Form onSubmit={formik.handleSubmit}>
                <FormGroup>
                  <Label className="form-control-label">About Us</Label>
                  <TextEditor
                    value={formik.values.aboutUs}
                    onChange={(html) => {
                      formik.setFieldValue("aboutUs", html)
                      formik.setFieldTouched("aboutUs", true, false);
                    }}
                    onBlur={() => formik.setFieldTouched("aboutUs", true)}
                    placeholder="Enter your terms and conditions here..."
                    hideImageAndLink={false}
                  />
                  {formik.touched.aboutUs && formik.errors.aboutUs && (
                    <div className="text-danger small mt-1">
                      {formik.errors.aboutUs}
                    </div>
                  )}
                </FormGroup>

                <div className="text-center d-flex align-items-center justify-content-center">
                  <Button className="mb-3 d-flex align-items-center justify-content-center" color="primary" type="submit" disabled={buttonLoading}>
                    {buttonLoading ? <span className="button-loader"></span> : "Submit"}
                  </Button>

                </div>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>)}
    </>
  );
};

export default AboutUs;